import React from "react";
import NoSearchitems from "./NoSearchitems";

const InterestCalculation = ({ data }) => {
  function truncateText(text, maxLength = 40) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  return (
    <div className="pt-3">
      <div className="flex justify-between items-center">
        <p className=" text-sm font-semibold">Interest Calculation</p>
      </div>
      <div className="rounded-lg border border-[#E6EBED] mt-4 overflow-auto">
        <table className="w-full min-w-[1160px] box-border flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold">
            <tr className="w-full flex items-center">
              <th className="text-left pl-6 pt-1 pb-3 w-[25%]">Month</th>
              <th className={`text-left w-[25%]`}>Principal Outstanding</th>

              {/* <th className="text-right w-[15%] pl-14">Days</th> */}
              <th className={`text-right w-[25%] pr-40`}>Rate (%) </th>
              <th className={`text-left w-[25%] pl-32`}>Interest</th>
            </tr>
          </thead>

          <tbody className={`   ${data?.length === 0 ? " " : ""}`}>
            {data?.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}
            {data?.map((item, index) => (
              <tr
                className={`text-xs font-medium w-full flex items-center h-[43px] ${
                  index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                }`}
              >
                <td className="text-left pl-6 w-[25%]">{item.month || "--"}</td>
                <td className={`text-left w-[25%] pt-3 pb-2`}>
                  {formatToIndianRupees(item.principal_outstanding) || "--"}
                </td>
                {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                <td className={`text-right w-[25%] pr-40`}>
                  {item.rate || "--"}
                </td>
                <td className={`text-left w-[25%] pl-32`}>
                  {formatToIndianRupees(item.interest) || "--"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InterestCalculation;
